export default {"src":"/_next/static/media/icon-expired-link.2517eb9c.svg","height":63,"width":61,"blurWidth":0,"blurHeight":0};